const GravPopups = (function ($) {
	return class {
		constructor() {
			this.isShowing = false;

			$(window).on('gravitate-popups-show', (event, isShowing) => {
				this.isShowing = isShowing;
				this.accommodateForPopup();
			});

			$(window).resize(() => {
				if (this.isShowing) {
					this.accommodateForPopup();
				}
			});
		}

		accommodateForPopup() {
			const popupHeight = $('.gravitate-popups').outerHeight();
			const $body = $('body');
			const $siteHeaderVariable = $('.site-header__variable');
			const $siteHeaderFixed = $('.site-header__fixed');
			const $siteHeaderMobile = $('.site-header__mobile');

			if (this.isShowing) {
				$body.css('margin-top', popupHeight);
				$siteHeaderFixed.css('margin-top', popupHeight);
				$siteHeaderMobile.css('margin-top', popupHeight);

				if ($(window).width() >= 1024) {
					$siteHeaderVariable.css('margin-top', popupHeight);
				} else {
					$siteHeaderVariable.css('margin-top', 0);
				}
			} else {
				$body.css('margin-top', 0);
				$siteHeaderVariable.css('margin-top', 0);
				$siteHeaderFixed.css('margin-top', 0);
				$siteHeaderMobile.css('margin-top', 0);
			}

			// adjust Intercom icon position when the hellobar is showing
			// if (typeof window.Intercom === 'function') {
			// 	window.intercomSettings.vertical_padding = this.isShowing
			// 		? $('.gravitate-popups').outerHeight() + 15
			// 		: 0;

			// 	window.Intercom('update');
			// }
		}
	};
})(jQuery);

export default GravPopups;
